
const FavoriteTractsHeader = () => {
    
    return (
        
        <div className="col-6">
            <div className="container">
                <div className="row">
                    <div className="col-2 col-md-offset-3">
                        <div className="container-map"> Favorite Tracts</div>
                    </div>
                    <div className="col-2">
                        <div className="text-center container-buttons">Acreage</div>
                    </div>
                    <div className="col-3">
                        <div className="text-center container-buttons">Assigned To</div>
                    </div>
                    <div className="col-2">
                        <div className="text-center container-buttons">Status</div>
                    </div>
                </div>
            </div>
        </div>
        
    )
    
}

export default FavoriteTractsHeader
